import { hashRRN, onlyDigits } from './rrn';

export default function voterRRN() {
  return {
    privacyPolicyChecked: false,

    init() {
      const form = this.$refs.form;
      const rrn = this.$refs.rrn;

      if (form && rrn) {
        this.formatAsRRN(rrn);
        this.hashOnSubmit(form, rrn);
      }
    },

    hashOnSubmit(form, rrn) {
      form.addEventListener('submit', () => {
        this.$refs.hashedRRN.value = hashRRN(rrn.value);
      });
    },

    formatAsRRN(rrn) {
      rrn.addEventListener('input', (evt) => {
        const value = onlyDigits(evt.target.value);
        const rrn1 = [value.slice(0, 2), value.slice(2, 4), value.slice(4, 6)].filter((value) => !!value).join('.');
        const rrn2 = [value.slice(6, 9), value.slice(9, 11)].filter((value) => !!value).join('.');
        rrn.value = [rrn1, rrn2].filter((value) => !!value).join('-');
      });
    },
  };
}
